export var truncateText = function truncateText(length) {
  return function (text) {
    return text.length > length ? text.substring(0, length) + '...' : text;
  };
};